// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__JnaVO","primary":"Button_primary__VIPCG","back":"Button_back__E849q","position":"Button_position__sHI8V"};